// 接口状态码
export const enum API_RESULT_CODE {
  SUCCESS = 0, // 成功
  NEED_LOGIN = 250004, // 需要登录
  AUTH_INVAILD_TOKEN = 250008, // token 无效
  UN_AUTHENTICATED = 250007, // 账号类型错误或权限不足
  APP_SUCCESS = 200, //app请求成功
  APP_TREND_AUDIT_FAIL = 310004,
  APP_TREND_AUDIT_PENDING = 310005,
  APP_TREND_SECRET = 310006,
  APP_TREND_NOT_EXIST = 310001, // 动态不存在或已删除
  SERVICE_UPDATING = -9, // 服务升级中
}

export interface ResponseProps<T> {
  code: API_RESULT_CODE;
  msg: string;
  data: T;
}

// 私有\公有 private\public-read
export enum FileAcl {
  PUBLIC = "public-read",
  PRIVATE = "private",
}

export type PromiseResponseProps<T> = Promise<ResponseProps<T>>;

export type PaginationDataProps<T> = {
  list: T[];
  current: number; // 当前第几页
  size: number; // 每页条数
  total: number; // 总条数
  pages: number; // 总页数
  [key: string]: any;
};

export type PromiseResponseDataProps<T> = Promise<PaginationDataProps<T>>;

// 阿里验证码的配置
export const AWSC = {
  prefix: "qdbx7z", // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
  SceneId: "1gn677pz", // 场景ID。通过步骤一添加验证场景后，您可以在验证码场景列表，获取该场景的场景ID
};

export enum DictType {
  COMPANY_TYPE = "organizationType", // 教育经历
  TOP_PAGE = "top_page", // 社区置顶页面
  MOMENT_TAG = "moment_tag", // 动态标签
  MOMENT_AUDIT_DENY = "moment_audit_deny", // 动态审核不通过类型
  // PROPERTY_ONCALL = "property_oncall", // 物业客服电话
  ADVICE_TYPE = "suggestion_type", // 物业信箱意见类型
  WISH_WALL_CATEGORY = "wish_wall_category", // 心愿墙分类
  AWARD_LEVEL = "award_level", //奖励级别
  RAPID_TEAM_LEVEL = "raiding_team_level", //  突击队: 团队等级
  AWARD_TYPE = "award_type", //奖励类型
  PERSON_HONOR = "person_honor", // 奖励名称
  RELATION_TYPE = "relation_type", // 亲属类型
  GENDER = "gender", // 性别
  TEAM_BUILDING_TYPE = "team_building_type", // 业务分类
  FOREFRONT_REWARD_SESSION = "forefront_reward_session", // 届次
  FOREFRONT_REWARD_LEVEL = "forefront_reward_level", // 获奖等级
  TEAM_BUILDING_HONOR = "team_building_honor", // 团队建设奖励名称
  INNOVATION_STUDIO_TYPE = "innovation_studio_type", // 工作室类型选项
  RACE_TRACK = "race_track", // 赛道
}

export interface DictOption {
  value: string | number;
  label: string;
  children?: DictOption[];
}

export interface FileInfo {
  id?: string;
  fileId: string; // 上传id
  size?: string; //大小
  md5?: string; //md5
  fileType: string; // 文件类型 png\jpg\mp4\mp3\doc\other
  resourceType: string; //资源类型 image\video 暂不支持 audio\doc\other
  acl: FileAcl; // 私有\公有 private\public-read
  fileName: string; // 文件名
  path: string; // 路径 图片路径或视频id
  storageType?: string; //存储类型 aliyun\qiniu\minio
  ossBucket?: string; //存储桶
  uploadTime?: string; //上传时间 yyyy-MM-dd HH:mm:ss
  url?: string; // 非必须文件 URL，记录文件在 OSS 中的 URL，可以用来直接访问文件。
  width?: string; // 宽度
  height?: string; //高度
  coverUrl?: string; // 封面图地址
  fileSource?: string; // 文件来源 默认社区guopin
  contentLength?: number;
}

export type DictItem = {
  dictValue: string;
  dictLabel: string;
  desc: string;
  children?: DictItem[];
};

export type DictData = {
  dictType: string;
  dictTypeLabel: string;
  dictList: DictItem[];
};
